class NotificationPopupCard extends HTMLElement {
  connectedCallback() {
    this.popupSection = this.closest(".not-pu-card-section");
    if (!this.popupSection) return;

    this.closeBtn = this.popupSection.querySelector(".newsletter-card-popup__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopupCard=true");

    if (this.hasSubscription || this.cookie) return;

    setTimeout(() => {
      this.popupSection.classList.remove("hidden");
      this.popupSection.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.popupSection.classList.add("hidden");
        this.setCookie("hideNotificationPopupCard", "true", 7);
      });
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup-card", NotificationPopupCard);
